const EntityTypeNames = {
    /**
     * Event
     */
    EventReservation: 'EventReservation',

    /**
     * Flight
     */
    FlightReservation: 'FlightReservation',

    /**
     * Food
     */
    FoodReservation: 'FoodEstablishmentReservation',

    /**
     * Invoice
     */
    Invoice: 'Invoice',

    /**
     * Hotel
     */
    LodgingReservation: 'LodgingReservation',

    /**
     * Parcel Delivery
     */
    ParcelDelivery: 'ParcelDelivery',

    /**
     * Rental car
     */
    RentalCarReservation: 'RentalCarReservation',

    /**
     * Service reservation
     */
    ServiceReservation: 'ServiceReservation',

    /**
     * Unsuccessful flight reservation
     */
    UnsuccessfulFlightReservation: 'UnsuccessfulFlightReservation',

    /**
     * Unsuccessful hotel reservation
     */
    UnsuccessfulLodgingReservation: 'UnsuccessfulLodgingReservation',

    /**
     * Unsuccessful rental car
     */
    UnsuccessfulRentalCarReservation: 'UnsuccessfulRentalCarReservation',
};

export default EntityTypeNames;
